import { render, staticRenderFns } from "./TabBadgePropertiesCounter.vue?vue&type=template&id=754008fb&"
import script from "./TabBadgePropertiesCounter.vue?vue&type=script&lang=ts&"
export * from "./TabBadgePropertiesCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports